<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="toc01">
<h2 class="chaptertitle">CONTENTS</h2>
</a><p class="toc"><a id="toc01"></a><a href="#/acknowledgments"><i>Acknowledgments</i></a></p>
<p class="toc"><a href="#/frontmatter01"><i>A Word on the Orthography and Pronunciation</i></a></p>
<p class="toc1"><a href="#/chapter01">1.   Geographies of Borrowed Time</a></p>
<p class="toc2"><span href="#/chapter02" title="Link target outside of Sample">2.   Overland on Foot, Aloft:</span></p>
<p class="toc3"><span href="#/chapter02#sub_1" title="Link target outside of Sample"><i>An Anatomy of the Social Structure</i></span></p>
<p class="toc2"><span href="#/chapter03" title="Link target outside of Sample">3.   Land and Languor</span></p>
<p class="toc3"><span href="#/chapter03#sub_2" title="Link target outside of Sample"><i>On What Makes Good Work</i></span></p>
<p class="toc2"><span href="#/chapter04" title="Link target outside of Sample">4.   Toward a New Nature</span></p>
<p class="toc3"><span href="#/chapter04#sub_3" title="Link target outside of Sample"><i>Rank and Value in Conservation Bureaucracy</i></span></p>
<p class="toc2"><span href="#/chapter05" title="Link target outside of Sample">5.   Contracting Space</span></p>
<p class="toc3"><span href="#/chapter05#sub_4" title="Link target outside of Sample"><i>Making Deals in a Global Hot Spot</i></span></p>
<p class="toc2"><span href="#/chapter06" title="Link target outside of Sample">6.   How the Dead Matter</span></p>
<p class="toc3"><span href="#/chapter06#sub_5" title="Link target outside of Sample"><i>The Production of Heritage</i></span></p>
<p class="toc2"><span href="#/chapter07" title="Link target outside of Sample">7.   Cooked Rice Wages</span></p>
<p class="toc3"><span href="#/chapter07#sub_6" title="Link target outside of Sample"><i>Internal Contradiction and Subjective Experience</i></span></p>
<p class="toc4"><span href="#/epilogue" title="Link target outside of Sample">Epilogue: <i>Workers of the Vanishing World</i></span></p>
<p class="toc"><span href="#/glossary" title="Link target outside of Sample"><i>Glossary of Malagasy Words</i></span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2b6fe8a7